import { render, staticRenderFns } from "./PoiList.vue?vue&type=template&id=5867c514&scoped=true&"
import script from "./PoiList.vue?vue&type=script&lang=js&"
export * from "./PoiList.vue?vue&type=script&lang=js&"
import style0 from "./PoiList.vue?vue&type=style&index=0&id=5867c514&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5867c514",
  null
  
)

export default component.exports